import Home from '../views_kcis/index';
import Dashboard from '../views_kcis/dashboard';
import HomeDashboard from '../views_kcis/home_dashboard';
import ConsolidatedReport from '../views_kcis/consolidated_report';
import EmailSetting from '../views_kcis/email_setting';
import AdminChangePassword from '../views_kcis/admin_change_password';
import HeatMap from '../views_kcis/heat-map';
import Enquiries from '../views_kcis/enquiries';
import InternalEnquiries from '../views_kcis/enquiries_internal';
import TodayFollowup from '../views_kcis/today_followup';
import TodayReminder from '../views_kcis/today_reminder';
import MissedFollowup from '../views_kcis/missed_followup';
import EnquiriesAdd from '../views_kcis/enquiries_add';
import EnquiriesAddApp from '../views_kcis/enquiries_add_app';
import EnquiriesView from '../views_kcis/enquiries_view';
import EnquiriesEdit from '../views_kcis/enquiries_edit';
import EnquiriesEditApp from '../views_kcis/enquiries_edit_app';
import EnquiriesLinkAdd from '../views_kcis/enquiries_link_add';
import EnquiriesAdmission from '../views_kcis/enquiries_admission';
import EnquiriesEnroll from '../views_kcis/enquiries_enroll';
import EnquiriesDelete from '../views_kcis/enquiries_delete';
import TodayReport from '../views_kcis/today_report';
import Login from '../views_kcis/login';
import Validate from '../views_kcis/validate';
import Logout from '../views_kcis/logout';
import chat from '../views_kcis/chat';
import UpcomingBusExpiry from '../views_kcis/upcoming_bus_expiry';
import ExpiredBusList from '../views_kcis/expired_bus_list';
import App404 from '../views_kcis/app_404';

/* Email Report */
import EmailReport from '../views_kcis/email-report/index';

/* Manage Class */
import ManageClass from '../views_kcis/manage-class/index';
import ManageClassAdd from '../views_kcis/manage-class/add';
import ManageClassEdit from '../views_kcis/manage-class/edit';
import ManageDivision from '../views_kcis/manage-class/division-list';
import ManageDivisionAdd from '../views_kcis/manage-class/division-add';
import ManageDivisionEdit from '../views_kcis/manage-class/division-edit';
import ManageSubject from '../views_kcis/manage-class/subject-list';
import ManageSubjectAdd from '../views_kcis/manage-class/subject-adds';
import ManageSubjectEdit from '../views_kcis/manage-class/subject-edit';
import Managestar from '../views_kcis/manage-class/star-list';
import ManagestarAdd from '../views_kcis/manage-class/star-add';
import ManagestarEdit from '../views_kcis/manage-class/star-edit';

/* settings */
import Settings from '../views_kcis/settings/index';
import SettingsFees from '../views_kcis/settings/fees/index';
import SettingsFeesCategory from '../views_kcis/settings/fees/fees_category/index';
import SettingsFeesPackage from '../views_kcis/settings/fees/fees_package/index';
import SettingsFeesPackageManage from '../views_kcis/settings/fees/fees_package/fees_package_manage';
import SettingsFeesPackageManageAdd from '../views_kcis/settings/fees/fees_package/fees_package_manage_add';
import SettingsFeesPackageManageEdit from '../views_kcis/settings/fees/fees_package/fees_package_manage_edit';
import SettingsFeesCategoryAdd from '../views_kcis/settings/fees/fees_category/fees_category_add';
import SettingsFeesCategoryEdit from '../views_kcis/settings/fees/fees_category/fees_category_edit';
import SettingsFeesPackageAdd from '../views_kcis/settings/fees/fees_package/fees_package_add';
import SettingsFeesPackageEdit from '../views_kcis/settings/fees/fees_package/fees_package_edit';
import SettingsAssignFeesPackage from '../views_kcis/settings/fees/assign_fees_package/index';
import SettingsMandatoryFeesAdd from '../views_kcis/settings/fees/assign_fees_package/mandatory_add';


import FeesInvoices from '../views_kcis/settings/fees/fees_invoices/index';
import FeesInvoicesDetails from '../views_kcis/settings/fees/fees_invoices/details';

import PreAdmissionFeesSetting from '../views_kcis/settings/fees/pre-admission-fees/index'
import PreAdmissionFeesSettingAdd from '../views_kcis/settings/fees/pre-admission-fees/fees-setting-add'
import PreAdmissionFeesSettingEdit from '../views_kcis/settings/fees/pre-admission-fees/fees-setting-edit'




/* Food */
import Food from '../views_kcis/food/index';

/* qr-download */
import QrDownloadChildren from '../views_kcis/qr-download/children';

/* dayplan */
import Dayplan from '../views_kcis/dayplan/index';

/* diary */
import Diary from '../views_kcis/diary/index';

/* star */
import Star from '../views_kcis/star/index';

/* potty */
import Potty from '../views_kcis/potty/index';

/* health */
import Health from '../views_kcis/health/index';

/* observations */
import Observations from '../views_kcis/observations/index';

/* observations */
import Photos from '../views_kcis/photos/index';

/* play-learn */
import PlayLearn from '../views_kcis/play-learn/index';

/* sleep */
import Sleep from '../views_kcis/sleep/index';

/* video-upload */
import VideoUpload from '../views_kcis/video-upload/index';

/* attendance */
import Attendance from '../views_kcis/attendance/index';
import AttendanceStaff from '../views_kcis/attendance/staff-attendance';
import AttendanceMonthStudent from '../views_kcis/attendance/student-month-attendance';

/* time-table */
import TimeTable from '../views_kcis/time-table/index';
import TimeTableAdd from '../views_kcis/time-table/add';
import TimeTableEdit from '../views_kcis/time-table/edit';
import TimeTablePeriodEdit from '../views_kcis/time-table/period-edit';
import TimeTableManage from '../views_kcis/time-table/manage';
import TimeTableView from '../views_kcis/time-table/view';
import TimeTableList from '../views_kcis/time-table/list';
import TimeTableReview from '../views_kcis/time-table/review';
import TimeTableWhoIsFree from '../views_kcis/time-table/who-is-free';
import TimeTableLectureLimit from '../views_kcis/time-table/lecture-limit';
import TimeTableSatffDetails from '../views_kcis/time-table/satff-details';

/* notice-board */
import NoticeBoard from '../views_kcis/notice-board/index';
import AddNotice from '../views_kcis/notice-board/add-notice';
import EditNotice from '../views_kcis/notice-board/edit';

/* parent-notes */
import ParentNotes from '../views_kcis/parent-notes/index';
import NotesDetails from '../views_kcis/parent-notes/notes-details';

/* route-tracker */
import RouteTracker from '../views_kcis/route-tracker/index';

/* daily-report */
import DailyReport from '../views_kcis/daily-report/index';
import StaffDailyReport from '../views_kcis/daily-report/staff';
import NonStaffDailyReport from '../views_kcis/daily-report/non-teaching-staff';
import DailyReport_ from '../views_kcis/daily-report/daily-report';


/* staff-profiles */
import StaffProfiles from '../views_kcis/staff-profiles/index';
import Profile from '../views_kcis/staff-profiles/profile';
import StaffEditProfile from '../views_kcis/staff-profiles/edit-profile';
import StaffAddProfile from '../views_kcis/staff-profiles/add-profile';

/* programs */
import Programs from '../views_kcis/programs/index';
import ViewProgram from '../views_kcis/programs/view-program';

import EditPrograms from '../views_kcis/programs/edit';
import AddProgram from '../views_kcis/programs/add-program';


/* school-profile */
import SchoolProfile from '../views_kcis/school-profile/index';
import EditSchool from '../views_kcis/school-profile/edit-school';


/* archives */
import Archives from '../views_kcis/archives/index';


/* room-ratio */
import RoomRatio from '../views_kcis/room-ratio/index';
import RoomratioDetails from '../views_kcis/room-ratio/roomratio-details';

/* favourite-school */
import FavouriteSchool from '../views_kcis/favourite-school/index';

/* invite-parents */
import InviteParents from '../views_kcis/invite-parents/index';

/* invite-staff */
import InviteStaff from '../views_kcis/invite-staff/index';

/* tags */
import Tags from '../views_kcis/tags/index';
import TagsDetails from '../views_kcis/tags/tags-details';
import TagsAdd from '../views_kcis/tags/tags-add';
import TagsEdit from '../views_kcis/tags/tags-edit';

/* cctv */
import Cctv from '../views_kcis/cctv/index';
import EditCctv from '../views_kcis/cctv/edit-cctv';
import AddCctv from '../views_kcis/cctv/add-cctv';

/* help-video */
import HelpVideo from '../views_kcis/help-video/index';
import ViewVideo from '../views_kcis/help-video/view-video';

/* faqs */
import Faqs from '../views_kcis/faqs/index';
import FaqsDetails from '../views_kcis/faqs/faqs-details';

/* configurations */
import Configurations from '../views_kcis/configurations/index';

/* allergy-info */
import AllergyInfo from '../views_kcis/allergy-info/index';


/* student-reports/ */
import StudentReports from '../views_kcis/student-reports/index';
import StudentReportsAdd from '../views_kcis/student-reports/student-reports-add';
import StudentReportsEdit from '../views_kcis/student-reports/student-reports-edit';
import ChildrenProfilesStudentReports from '../views_kcis/children-profiles/student-reports';




/* transport-setup */
import TransportSetup from '../views_kcis/transport-setup/index';
import Drivers from '../views_kcis/transport-setup/drivers';
import DriversAdd from '../views_kcis/transport-setup/drivers-add';
import DriversEdit from '../views_kcis/transport-setup/drivers-edit';
import PickupPoints from '../views_kcis/transport-setup/pickup-points';
import PickupPointsEdit from '../views_kcis/transport-setup/pickup-points-edit';
import PickupPointsAdd from '../views_kcis/transport-setup/pickup-points-add';
import Routes from '../views_kcis/transport-setup/routes';
import RoutesEdit from '../views_kcis/transport-setup/routes-edit';
import RoutesAdd from '../views_kcis/transport-setup/routes-add';
import RouteTrackers from '../views_kcis/transport-setup/route-tracker';
import RouteTrackersHistory from '../views_kcis/transport-setup/route-tracker-history';


import ManageRouteStop from '../views_kcis/transport-setup/manage-route/stop';
import ManageRouteStopAdd from '../views_kcis/transport-setup/manage-route/stop-add';
import ManageRouteStopEdit from '../views_kcis/transport-setup/manage-route/stop-edit';
import ManageRouteRoute from '../views_kcis/transport-setup/manage-route/route';
import ManageRouteRouteAdd from '../views_kcis/transport-setup/manage-route/route-add';
import ManageRouteRouteEdit from '../views_kcis/transport-setup/manage-route/route-edit';
import ManageRouteComposeRoute from '../views_kcis/transport-setup/manage-route/compose-route';
import ManageRouteComposeRouteAdd from '../views_kcis/transport-setup/manage-route/compose-route-add';
import ManageRouteComposeRouteEdit from '../views_kcis/transport-setup/manage-route/compose-route-edit';
import ManageRouteAssignRouteDriver from '../views_kcis/transport-setup/manage-route/assign-route-driver';
import ManageRouteAssignRouteDriverAdd from '../views_kcis/transport-setup/manage-route/assign-route-driver-add';
import ManageRouteAssignRouteDriverEdit from '../views_kcis/transport-setup/manage-route/assign-route-driver-edit';
import ManageRouteManageBus from '../views_kcis/transport-setup/manage-bus';
import ManageRouteManageBusAdd from '../views_kcis/transport-setup/manage-bus-add';
import ManageRouteManageBusEdit from '../views_kcis/transport-setup/manage-bus-edit';
import ManageRouteManageStudent from '../views_kcis/transport-setup/manage-route/manage_student';
import ManageRouteManageStudentReport from '../views_kcis/transport-setup/manage-route/manage_student-report';
import ManageRouteManageStudentAdd from '../views_kcis/transport-setup/manage-route/manage-student-add';
import ManageRouteManageStudentEdit from '../views_kcis/transport-setup/manage-route/manage-student-edit';
import CheckRoute from '../views_kcis/transport-setup/manage-route/check-route';
import CheckRouteDetails from '../views_kcis/transport-setup/manage-route/check-route-details';
import CheckRouteAttendance from '../views_kcis/transport-setup/manage-route/check-route-attendance';
import OngoingRoute from '../views_kcis/transport-setup/manage-route/ongoing-route';
import BusOnMap from '../views_kcis/transport-setup/manage-route/bus-on-map'; 
import OngoingRouteHistory from '../views_kcis/transport-setup/manage-route/ongoing-route-history';
import OngoingRouteHistoryDetails from '../views_kcis/transport-setup/manage-route/ongoing-route-history-details';
import OngoingRouteDetails from '../views_kcis/transport-setup/manage-route/ongoing-route-details';

/* Fees Report */
import FeesSuccessReport from '../views_kcis/fees/success';
import FeesSuccessReportView from '../views_kcis/fees/view';

import ConcernView from '../views_kcis/concern/index';
import StaffConcernView from '../views_kcis/concern/staff';

/* Fees Reconciliation*/
import FeesReconciliationReport from '../views_kcis/fees-reconciliation/pending';
import FeesRefund from '../views_kcis/fees-refund/index';

/* transport-setup */
import ChildrenProfiles from '../views_kcis/children-profiles/index';
import ChildrenProfilesAdd from '../views_kcis/children-profiles/children-profiles-add';
import ChildrenProfilesEdit from '../views_kcis/children-profiles/children-profiles-edit';
import ChildrenProfilesView from '../views_kcis/children-profiles/children-profiles-view';
import ChildrenAdmissionProcess from '../views_kcis/children-profiles/admission-process';
import ChildrenProfilesDocument from '../views_kcis/children-profiles/children-document';
import ChildrenProfilesFees from '../views_kcis/children-profiles/children-fees';
import ChildrenProfilesTransportFees from '../views_kcis/children-profiles/children-transport-fees';
import ChildrenProfilesDaycareFees from '../views_kcis/children-profiles/children-daycare-fees';
import ChildrenProfilesFeesPay from '../views_kcis/children-profiles/pay-children-fees';
import ChildrenProfilesFeesView from '../views_kcis/children-profiles/view-children-fees';
import ChildrenDeactive from '../views_kcis/children-profiles/children-deactive';
import AddmissionDeactive from '../views_kcis/children-profiles/admission-deactive';
import ChildrenAll from '../views_kcis/children-profiles/children-all';
import ChildrenPromote from '../views_kcis/children-profiles/children-promote';
import StudentFeesReport from '../views_kcis/children-profiles/student-fees-report';
import StudentTracker from '../views_kcis/children-profiles/student-tracker';
import ClassWiseTracker from '../views_kcis/children-profiles/class-wise-tracker';
import ClassWiseFees from '../views_kcis/children-profiles/class-wise-fees';
import AttendanceTracker from '../views_kcis/children-profiles/attendance-tracker';
import SchoolWiseTracker from '../views_kcis/children-profiles/school-wise-tracker';

/* reports */
import Reports from '../views_kcis/reports/index';
import ReportsAdmision from '../views_kcis/reports/reports_admision';
import FeePayment from '../views_kcis/reports/fee-payment';
import ChildrenAttendance from '../views_kcis/reports/children-attendance';
import StaffAttendance from '../views_kcis/reports/staff-attendance';
import StudentAttendanceReport from '../views_kcis/reports/student_attendance_report';
import StudentMonthAttendanceReport from '../views_kcis/reports/student_month_attendance_report';
import EnquiryReport from '../views_kcis/reports/enquiry_report';
import ChildrenReport from '../views_kcis/reports/children-report';
import ChildrenFeesReport from '../views_kcis/reports/children-fees-report';
import ChildrenFeesDueReport from '../views_kcis/reports/children-fees-due-report';
import ChildrenFeesChangeReport from '../views_kcis/reports/children-fees-change-report';
import ChildrenFeesReportDetails from '../views_kcis/reports/children-fees-report-details';
import PtmReport from '../views_kcis/reports/ptm-report';
import PtmReportDetails from '../views_kcis/reports/ptm-report-details';
import AccountFeesReport from '../views_kcis/reports/account-fees-report';
import AccountDayWiseFeesReport from '../views_kcis/reports/account-day-wise-fees-report';
import StudentEscortCardReport from '../views_kcis/reports/student_escort_card_report';
import TodayFeesReport from '../views_kcis/reports/today-fees-report';
import TransportReport from '../views_kcis/reports/transport-report';
import TodayEnquiryReport from '../views_kcis/reports/today-enquiry-report';
import TodayAdmissionReport from '../views_kcis/reports/today-admission-report';
import TodayConversionReport from '../views_kcis/reports/today-conversion-report';
import TodayFollowupReport from '../views_kcis/reports/today-followup-report';

/* history */
import History from '../views_kcis/history/index';

/* Expenses */
import Expenses from '../views_kcis/expenses/index';
import ExpensesAdd from '../views_kcis/expenses/expenses-add';
import ExpensesEdit from '../views_kcis/expenses/expenses-edit';

/* calendar */
import Calendar from '../views_kcis/calendar/index';
import AddEvent from '../views_kcis/calendar/add-event';
import EditEvent from '../views_kcis/calendar/edit-event';
import Map from '../views_kcis/map/heat-map';

import Shop from '../views_kcis/shop/index';

import ShopKit from '../views_kcis/shop_kit/index';

/* Profile */
import MainProfile from '../views_kcis/profile/index';
import ChangePassword from '../views_kcis/profile/change-password';


/* PrivacyPolicy */
import PrivacyPolicy from '../views_kcis/privacy-policy';


import TaskmanagerOngoing from '../views_kcis/task-manager/ongoing'
import TaskmanagerOngoingAdd from '../views_kcis/task-manager/ongoing-add'
import TaskmanagerOngoingEdit from '../views_kcis/task-manager/ongoing-edit'
import TaskmanagerOngoingTimeline from '../views_kcis/task-manager/ongoing-timeline'
import TaskmanagerCompleted from '../views_kcis/task-manager/completed'

import ChallanReceiptSettings from '../views_kcis/settings/fees/other/challan-receipt-settings';
import OnlineFeesSettings from '../views_kcis/settings/fees/other/online-fees-settings';

import FeesReceipt from '../views_kcis/settings/fees/other/print-setting';
import ReceiptSettings from '../views_kcis/settings/fees/other/receipt-settings';
import ReceiptPassword from '../views_kcis/settings/fees/other/receipt-password';
import FeesTransportSetting from '../views_kcis/settings/fees/other/fees-transport-setting';
import AccountFeesLinking from '../views_kcis/settings/fees/other/account-fees-linking';
import SetPaymentIndicator from '../views_kcis/settings/fees/other/set-payment-indicator';

import AssignCoupons from '../views_kcis/settings/fees/other/assign-coupons';
import AssignCouponsAdd from '../views_kcis/settings/fees/other/assign-coupons-add';
import AssignCouponsEdit from '../views_kcis/settings/fees/other/assign-coupons-edit';

import ConcessionCoupons from '../views_kcis/settings/fees/other/concession-coupons';
import ConcessionCouponsAdd from '../views_kcis/settings/fees/other/concession-coupons-add';
import ConcessionCouponsEdit from '../views_kcis/settings/fees/other/concession-coupons-edit';
import CategoryInstallmentStructure from '../views_kcis/settings/fees/other/category-installment-structure';
import CategoryInstallmentOptional from '../views_kcis/settings/fees/other/category-installment-optional';
import CategoryInstallmentOthers from '../views_kcis/settings/fees/other/category-installment-others';

/* store-house/ */
import StoreHouse from '../views_kcis/store-house/index';
import StoreHouseAdd from '../views_kcis/store-house/store-house-add';
import StoreHouseEdit from '../views_kcis/store-house/store-house-edit';


import QrCheck from '../views_kcis/qr-check/index';
import Notification from '../views_kcis/notification/index';

import MySchool from '../views_kcis/my-school/index';
import MySchoolAdd from '../views_kcis/my-school/my-school-add';
import MySchoolEdit from '../views_kcis/my-school/my-school-edit';
import MySchoolView from '../views_kcis/my-school/my-school-view';

/* Leads */
import LeadsDashboard from '../views_kcis/leads/dashboard';
import LeadsAdd from '../views_kcis/leads/add';
import LeadsList from '../views_kcis/leads/list';
import MissedLeadsList from '../views_kcis/leads/missed';
import TodayLeadsList from '../views_kcis/leads/today';
import MoveLeadsList from '../views_kcis/leads/move';
import MoveEnquiryLeadsList from '../views_kcis/leads/enquiry';
import LeadsEdit from '../views_kcis/leads/edit';
import LeadsEnroll from '../views_kcis/leads/lead_enroll';


var KCISThemeRoutes = [

	{
		collapse: false,
		name: "Logout",
		path: "/logout",
		component: Logout
	},
	{
		collapse: false,
		name: "chat",
		path: "/chat",
		component: chat
	},
	{
		collapse: false,
		name: "LeadsDashboard",
		path: "/leads/dashboard",
		component: LeadsDashboard
	},
	{
		collapse: false,
		name: "LeadsList",
		path: "/leads/list",
		component: LeadsList
	},
	{
		collapse: false,
		name: "MissedLeadsList",
		path: "/leads/missed",
		component: MissedLeadsList
	},
	{
		collapse: false,
		name: "TodayLeadsList",
		path: "/leads/today",
		component: TodayLeadsList
	},
	{
		collapse: false,
		name: "MoveLeadsList",
		path: "/leads/move",
		component: MoveLeadsList
	},
	{
		collapse: false,
		name: "MoveEnquiryLeadsList",
		path: "/enquiries/leads",
		component: MoveEnquiryLeadsList
	},
	{
		collapse: false,
		name: "LeadsEdit",
		path: "/leads/edit/:id",
		component: LeadsEdit
	},
	{
		collapse: false,
		name: "LeadsEnroll",
		path: "/leads/enroll/:id",
		component: LeadsEnroll
	},
	{
		collapse: false,
		name: "LeadsAdd",
		path: "/leads/add",
		component: LeadsAdd
	},
	{
		collapse: false,
		name: "Validate",
		path: "/validate/:text/:link",
		component: Validate
	},
	{
		collapse: false,
		name: "StoreHouseAdd",
		path: "/store-house/add",
		component: StoreHouseAdd
	},

	{
		collapse: false,
		name: "MySchoolAdd",
		path: "/my-school/my-school-add",
		component: MySchoolAdd
	},
	{
		collapse: false,
		name: "MySchoolEdit",
		path: "/my-school/my-school-edit/:id",
		component: MySchoolEdit
	},
	{
		collapse: false,
		name: "MySchoolView",
		path: "/my-school/my-school-view/:id",
		component: MySchoolView
	},
	{
		collapse: false,
		name: "MySchool",
		path: "/my-school",
		component: MySchool
	},

	{
		collapse: false,
		name: "StoreHouseEdit",
		path: "/store-house/edit/:id",
		component: StoreHouseEdit
	},

	{
		collapse: false,
		name: "QrCheck",
		path: "/qr-check",
		component: QrCheck
	},
	{
		collapse: false,
		name: "Notification",
		path: "/notification",
		component: Notification
	},


	{
		collapse: false,
		name: "StoreHouse",
		path: "/store-house/index",
		component: StoreHouse
	},


	{
		collapse: false,
		name: "ChildrenProfilesStudentReports",
		path: "/children-profiles/student-reports/:id",
		component: ChildrenProfilesStudentReports
	},

	{
		collapse: false,
		name: "StudentReportsAdd",
		path: "/student-reports/add",
		component: StudentReportsAdd
	},

	{
		collapse: false,
		name: "StudentReportsEdit",
		path: "/student-reports/edit/:id",
		component: StudentReportsEdit
	},


	{
		collapse: false,
		name: "StudentReports",
		path: "/student-reports/index",
		component: StudentReports
	},
	{
		collapse: false,
		name: "CategoryInstallmentOptional",
		path: "/settings/fees/category-installment-optional",
		component: CategoryInstallmentOptional
	},
	{
		collapse: false,
		name: "CategoryInstallmentOthers",
		path: "/settings/fees/category-installment-others",
		component: CategoryInstallmentOthers
	},
	{
		collapse: false,
		name: "CategoryInstallmentStructure",
		path: "/settings/fees/category-installment-structure",
		component: CategoryInstallmentStructure
	},

	{
		collapse: false,
		name: "AssignCouponsAdd",
		path: "/settings/fees/assign-coupons/add",
		component: AssignCouponsAdd
	},

	{
		collapse: false,
		name: "AssignCouponsEdit",
		path: "/settings/fees/assign-coupons/edit/:id",
		component: AssignCouponsEdit
	},

	{
		collapse: false,
		name: "AssignCoupons",
		path: "/settings/fees/assign-coupons",
		component: AssignCoupons
	},


	{
		collapse: false,
		name: "ConcessionCouponsAdd",
		path: "/settings/fees/concession-coupons/add",
		component: ConcessionCouponsAdd
	},

	{
		collapse: false,
		name: "ConcessionCouponsEdit",
		path: "/settings/fees/concession-coupons/edit/:id",
		component: ConcessionCouponsEdit
	},



	{
		collapse: false,
		name: "ConcessionCoupons",
		path: "/settings/fees/concession-coupons",
		component: ConcessionCoupons
	},
	{
		collapse: false,
		name: "SetPaymentIndicator",
		path: "/settings/fees/set-payment-indicator",
		component: SetPaymentIndicator
	},
	{
		collapse: false,
		name: "AccountFeesLinking",
		path: "/settings/fees/account-fees-linking",
		component: AccountFeesLinking
	},
	{
		collapse: false,
		name: "ReceiptSettings",
		path: "/settings/fees/receipt-settings",
		component: ReceiptSettings
	},
	{
		collapse: false,
		name: "ReceiptPassword",
		path: "/settings/fees/receipt-password",
		component: ReceiptPassword
	},
	{
		collapse: false,
		name: "FeesTransportSetting",
		path: "/settings/fees/fees-transport-setting",
		component: FeesTransportSetting
	},
	{
		collapse: false,
		name: "OnlineFeesSettings",
		path: "/settings/fees/online-fees-settings",
		component: OnlineFeesSettings
	},
	{
		collapse: false,
		name: "ChallanReceiptSettings",
		path: "/settings/fees/challan-receipt-settings",
		component: ChallanReceiptSettings
	},
	{
		collapse: false,
		name: "FeesReceipt",
		path: "/settings/fees/receipt",
		component: FeesReceipt
	},
	{
		collapse: false,
		name: "PreAdmissionFeesSetting",
		path: "/pre-admission-fees/index",
		component: PreAdmissionFeesSetting
	},
	{
		collapse: false,
		name: "PreAdmissionFeesSettingAdd",
		path: "/pre-admission-fees/fees-setting-add",
		component: PreAdmissionFeesSettingAdd
	},
	{
		collapse: false,
		name: "PreAdmissionFeesSettingEdit",
		path: "/pre-admission-fees/fees-setting-edit/:id",
		component: PreAdmissionFeesSettingEdit
	},
	{
		collapse: false,
		name: "TaskmanagerOngoing",
		path: "/task-manager/ongoing",
		component: TaskmanagerOngoing
	},
	{
		collapse: false,
		name: "TaskmanagerOngoingAdd",
		path: "/task-manager/ongoing-add",
		component: TaskmanagerOngoingAdd
	},
	{
		collapse: false,
		name: "TaskmanagerOngoingEdit",
		path: "/task-manager/ongoing-edit/:id",
		component: TaskmanagerOngoingEdit
	},
	{
		collapse: false,
		name: "TaskmanagerOngoingTimeline",
		path: "/task-manager/ongoing-timeline/:id",
		component: TaskmanagerOngoingTimeline
	},
	{
		collapse: false,
		name: "TaskmanagerCompleted",
		path: "/task-manager/completed",
		component: TaskmanagerCompleted
	},
	{
		collapse: false,
		name: "Login",
		path: "/login",
		component: Login
	},
	{
		collapse: false,
		name: "App404",
		path: "/app_404",
		component: App404
	},
	{
		collapse: false,
		name: "EnquiriesLinkAdd",
		path: "/enquiries_link_add/:id",
		component: EnquiriesLinkAdd
	},
	{
		collapse: false,
		name: "MissedFollowup",
		path: "/missed-followup",
		component: MissedFollowup
	},
	{
		collapse: false,
		name: "TodayFollowup",
		path: "/today-followup",
		component: TodayFollowup
	},
	{
		collapse: false,
		name: "TodayReminder",
		path: "/today-reminder",
		component: TodayReminder
	},
	{
		collapse: false,
		name: "HeatMap",
		path: "/heat-map",
		component: HeatMap
	},
	{
		collapse: false,
		name: "Enquiries",
		path: "/enquiries",
		component: Enquiries
	},
	{
		collapse: false,
		name: "InternalEnquiries",
		path: "/internal-enquiries",
		component: InternalEnquiries
	},
	{
		collapse: false,
		name: "EnquiriesAdd",
		path: "/enquiries_add",
		component: EnquiriesAdd
	},
	{
		collapse: false,
		name: "EnquiriesAddApp",
		path: "/enquiries_add_app",
		component: EnquiriesAddApp
	},
	{
		collapse: false,
		name: "EnquiriesView",
		path: "/enquiries_view/:id",
		component: EnquiriesView
	},
	{
		collapse: false,
		name: "EnquiriesEdit",
		path: "/enquiries_edit/:id",
		component: EnquiriesEdit
	},
	{
		collapse: false,
		name: "EnquiriesEditApp",
		path: "/enquiries_edit_app/:id",
		component: EnquiriesEditApp
	},
	{
		collapse: false,
		name: "EnquiriesAdmission",
		path: "/move-to-admission",
		component: EnquiriesAdmission
	},
	{
		collapse: false,
		name: "EnquiriesEnroll",
		path: "/enquiries_enroll/:id",
		component: EnquiriesEnroll
	},
	{
		collapse: false,
		name: "TodayReport",
		path: "/today-report",
		component: TodayReport
	},
	{
		collapse: false,
		name: "EnquiriesDelete",
		path: "/enquiries_archive",
		component: EnquiriesDelete
	},
	{
		collapse: false,
		name: "Food",
		path: "/food",
		component: Food
	},
	{
		collapse: false,
		name: "SettingsFeesCategoryEdit",
		path: "/settings/fees/fees_category/edit/:id",
		component: SettingsFeesCategoryEdit
	},
	{
		collapse: false,
		name: "SettingsFeesCategoryAdd",
		path: "/settings/fees/fees_category/add",
		component: SettingsFeesCategoryAdd
	},
	{
		collapse: false,
		name: "SettingsMandatoryFeesAdd",
		path: "/settings/fees/assign_fees_package/add/:text",
		component: SettingsMandatoryFeesAdd
	},
	{
		collapse: false,
		name: "FeesInvoices",
		path: "/fee-invoices",
		component: FeesInvoices
	},
	{
		collapse: false,
		name: "FeesInvoicesDetails",
		path: "/fee-invoices-details/:id",
		component: FeesInvoicesDetails
	},


	{
		collapse: false,
		name: "SettingsAssignFeesPackage",
		path: "/settings/fees/assign_fees_package",
		component: SettingsAssignFeesPackage
	},
	{
		collapse: false,
		name: "SettingsFeesPackageManage",
		path: "/settings/fees/fees_package/manage/:text",
		component: SettingsFeesPackageManage
	},
	{
		collapse: false,
		name: "SettingsFeesPackageManageEdit",
		path: "/settings/fees/fees_package/manage_edit/:id",
		component: SettingsFeesPackageManageEdit
	},
	{
		collapse: false,
		name: "SettingsFeesPackageManageAdd",
		path: "/settings/fees/fees_package/manage_add/:text",
		component: SettingsFeesPackageManageAdd
	},
	{
		collapse: false,
		name: "SettingsFeesPackageEdit",
		path: "/settings/fees/fees_package/edit/:id",
		component: SettingsFeesPackageEdit
	},
	{
		collapse: false,
		name: "SettingsFeesPackageAdd",
		path: "/settings/fees/fees_package/add",
		component: SettingsFeesPackageAdd
	},
	{
		collapse: false,
		name: "SettingsFeesPackage",
		path: "/settings/fees/fees_package",
		component: SettingsFeesPackage
	},
	{
		collapse: false,
		name: "SettingsFeesCategory",
		path: "/settings/fees/fees_category",
		component: SettingsFeesCategory
	},
	{
		collapse: false,
		name: "SettingsFees",
		path: "/settings/fees",
		component: SettingsFees
	},
	{
		collapse: false,
		name: "Settings",
		path: "/settings",
		component: Settings
	},
	{
		collapse: false,
		name: "Dayplan",
		path: "/dayplan",
		component: Dayplan
	},
	{
		collapse: false,
		name: "Diary",
		path: "/diary",
		component: Diary
	},
	{
		collapse: false,
		name: "QrDownloadChildren",
		path: "/qr-download/children",
		component: QrDownloadChildren
	},
	{
		collapse: false,
		name: "Star",
		path: "/star/index",
		component: Star
	},
	{
		collapse: false,
		name: "Potty",
		path: "/potty",
		component: Potty
	},
	{
		collapse: false,
		name: "Health",
		path: "/health",
		component: Health
	},
	{
		collapse: false,
		name: "Observations",
		path: "/observations/index",
		component: Observations
	},
	{
		collapse: false,
		name: "Class Story",
		path: "/class-story",
		component: Photos
	},
	{
		collapse: false,
		name: "PlayLearn",
		path: "/play-learn/index",
		component: PlayLearn
	},
	{
		collapse: false,
		name: "Sleep",
		path: "/sleep",
		component: Sleep
	},
	{
		collapse: false,
		name: "VideoUpload",
		path: "/video-upload/index",
		component: VideoUpload
	},
	{
		collapse: false,
		name: "Attendance",
		path: "/attendance",
		component: Attendance
	},
	{
		collapse: false,
		name: "AttendanceStaff",
		path: "/staff-attendance",
		component: AttendanceStaff
	},
	{
		collapse: false,
		name: "AttendanceMonthStudent",
		path: "/student-attendance/:id",
		component: AttendanceMonthStudent
	},
	{
		collapse: false,
		name: "TimeTableSatffDetails",
		path: "/time-table/satff-details",
		component: TimeTableSatffDetails
	},
	{
		collapse: false,
		name: "TimeTableLectureLimit",
		path: "/time-table/lecture-limit",
		component: TimeTableLectureLimit
	},
	{
		collapse: false,
		name: "TimeTableWhoIsFree",
		path: "/time-table/who-is-free",
		component: TimeTableWhoIsFree
	},
	{
		collapse: false,
		name: "TimeTableReview",
		path: "/time-table/review",
		component: TimeTableReview
	},
	{
		collapse: false,
		name: "TimeTableList",
		path: "/time-table/list",
		component: TimeTableList
	},
	{
		collapse: false,
		name: "TimeTableManage",
		path: "/time-table/manage",
		component: TimeTableManage
	},
	{
		collapse: false,
		name: "TimeTableView",
		path: "/time-table/view",
		component: TimeTableView
	},
	{
		collapse: false,
		name: "TimeTableEdit",
		path: "/time-table/edit/:id",
		component: TimeTableEdit
	},
	{
		collapse: false,
		name: "TimeTablePeriodEdit",
		path: "/time-table/period-edit/:tid/:id",
		component: TimeTablePeriodEdit
	},
	{
		collapse: false,
		name: "TimeTableAdd",
		path: "/time-table/add",
		component: TimeTableAdd
	},
	{
		collapse: false,
		name: "TimeTable",
		path: "/time-table",
		component: TimeTable
	},
	{
		collapse: false,
		name: "NoticeBoard",
		path: "/notice-board/index",
		component: NoticeBoard
	},
	{
		collapse: false,
		name: "AddNotice",
		path: "/notice-board/add-notice",
		component: AddNotice
	},
	{
		collapse: false,
		name: "EditNotice",
		path: "/notice-board/edit/:id",
		component: EditNotice
	},
	{
		collapse: false,
		name: "ParentNotes",
		path: "/parent-notes/index",
		component: ParentNotes
	},
	{
		collapse: false,
		name: "NotesDetails",
		path: "/parent-notes/notes-details/:id",
		component: NotesDetails
	},
	{
		collapse: false,
		name: "RouteTracker",
		path: "/route-tracker/index",
		component: RouteTracker
	},
	{
		collapse: false,
		name: "DailyReport",
		path: "/daily-report/index",
		component: DailyReport
	},
	{
		collapse: false,
		name: "DailyReport_",
		path: "/daily-report/daily-report/:id",
		component: DailyReport_
	},
	{
		collapse: false,
		name: "StaffDailyReport",
		path: "/daily-report/staff",
		component: StaffDailyReport
	},
	{
		collapse: false,
		name: "NonStaffDailyReport",
		path: "/daily-report/non-teaching-staff",
		component: NonStaffDailyReport
	},
	{
		collapse: false,
		name: "StaffProfiles",
		path: "/staff-profiles/index",
		component: StaffProfiles
	},
	{
		collapse: false,
		name: "Profile",
		path: "/staff-profiles/profile/:id",
		component: Profile
	},
	{
		collapse: false,
		name: "StaffEditProfile",
		path: "/staff-profiles/edit-profile/:id",
		component: StaffEditProfile
	},
	{
		collapse: false,
		name: "StaffAddProfile",
		path: "/staff-profiles/add-profile",
		component: StaffAddProfile
	},
	{
		collapse: false,
		name: "Programs",
		path: "/programs/index",
		component: Programs
	},
	{
		collapse: false,
		name: "ViewProgram",
		path: "/programs/view-program/:id",
		component: ViewProgram
	},
	{
		collapse: false,
		name: "EditPrograms",
		path: "/programs/edit/:id",
		component: EditPrograms
	},
	{
		collapse: false,
		name: "AddProgram",
		path: "/programs/add-program",
		component: AddProgram
	},
	{
		collapse: false,
		name: "SchoolProfile",
		path: "/school-profile/index",
		component: SchoolProfile
	},
	{
		collapse: false,
		name: "EditSchool",
		path: "/school-profile/edit-school",
		component: EditSchool
	},
	{
		collapse: false,
		name: "Archives",
		path: "/archives/index",
		component: Archives
	},
	{
		collapse: false,
		name: "RoomRatio",
		path: "/room-ratio/index",
		component: RoomRatio
	},
	{
		collapse: false,
		name: "RoomratioDetails",
		path: "/room-ratio/roomratio-details/:id",
		component: RoomratioDetails
	},
	{
		collapse: false,
		name: "FavouriteSchool",
		path: "/favourite-school/index",
		component: FavouriteSchool
	},
	{
		collapse: false,
		name: "InviteParents",
		path: "/invite-parents/index",
		component: InviteParents
	},
	{
		collapse: false,
		name: "InviteStaff",
		path: "/invite-staff/index",
		component: InviteStaff
	},
	{
		collapse: false,
		name: "Cctv",
		path: "/cctv/index",
		component: Cctv
	},
	{
		collapse: false,
		name: "EditCctv",
		path: "/cctv/edit-cctv/:id",
		component: EditCctv
	},
	{
		collapse: false,
		name: "AddCctv",
		path: "/cctv/add-cctv",
		component: AddCctv
	},
	{
		collapse: false,
		name: "Tags",
		path: "/tags/index",
		component: Tags
	},
	{
		collapse: false,
		name: "TagsDetails",
		path: "/tags/tags-details/:id",
		component: TagsDetails
	},
	{
		collapse: false,
		name: "TagsAdd",
		path: "/tags/tags-add/:id",
		component: TagsAdd
	},
	{
		collapse: false,
		name: "TagsEdit",
		path: "/tags/tags-edit/:id",
		component: TagsEdit
	},
	{
		collapse: false,
		name: "HelpVideo",
		path: "/help-video/index",
		component: HelpVideo
	},
	{
		collapse: false,
		name: "ViewVideo",
		path: "/help-video/view-video",
		component: ViewVideo
	},
	{
		collapse: false,
		name: "Faqs",
		path: "/faqs/index",
		component: Faqs
	},
	{
		collapse: false,
		name: "FaqsDetails",
		path: "/faqs/faqs-details",
		component: FaqsDetails
	},
	{
		collapse: false,
		name: "AllergyInfo",
		path: "/allergy-info/index",
		component: AllergyInfo
	},
	{
		collapse: false,
		name: "Configurations",
		path: "/configurations/index",
		component: Configurations
	},
	{
		collapse: false,
		name: "TransportSetup",
		path: "/transport-setup/index",
		component: TransportSetup
	},
	{
		collapse: false,
		name: "Drivers",
		path: "/transport-setup/drivers",
		component: Drivers
	},
	{
		collapse: false,
		name: "DriversAdd",
		path: "/transport-setup/drivers-add",
		component: DriversAdd
	},
	{
		collapse: false,
		name: "DriversEdit",
		path: "/transport-setup/drivers-edit/:id",
		component: DriversEdit
	},
	{
		collapse: false,
		name: "PickupPoints",
		path: "/transport-setup/pickup-points",
		component: PickupPoints
	},
	{
		collapse: false,
		name: "PickupPointsEdit",
		path: "/transport-setup/pickup-points-edit/:id",
		component: PickupPointsEdit
	},
	{
		collapse: false,
		name: "PickupPointsAdd",
		path: "/transport-setup/pickup-points-add",
		component: PickupPointsAdd
	},
	{
		collapse: false,
		name: "Routes",
		path: "/transport-setup/routes",
		component: Routes
	},
	{
		collapse: false,
		name: "RoutesEdit",
		path: "/transport-setup/routes-edit",
		component: RoutesEdit
	},
	{
		collapse: false,
		name: "RoutesAdd",
		path: "/transport-setup/routes-add",
		component: RoutesAdd
	},
	{
		collapse: false,
		name: "ManageRouteManageStudentEdit",
		path: "/transport-setup/manage-student-edit/:id",
		component: ManageRouteManageStudentEdit
	},
	{
		collapse: false,
		name: "ManageRouteManageStudentAdd",
		path: "/transport-setup/manage-student-add",
		component: ManageRouteManageStudentAdd
	},
	{
		collapse: false,
		name: "ManageRouteManageStudent",
		path: "/transport-setup/manage-student",
		component: ManageRouteManageStudent
	},
	{
		collapse: false,
		name: "ManageRouteManageStudentReport",
		path: "/transport-setup/manage-student-report",
		component: ManageRouteManageStudentReport
	},
	{
		collapse: false,
		name: "ManageRouteManageBusEdit",
		path: "/transport-setup/manage-bus-edit/:id",
		component: ManageRouteManageBusEdit
	},
	{
		collapse: false,
		name: "ManageRouteManageBusAdd",
		path: "/transport-setup/manage-bus-add",
		component: ManageRouteManageBusAdd
	},
	{
		collapse: false,
		name: "ManageRouteManageBus",
		path: "/transport-setup/manage-bus",
		component: ManageRouteManageBus
	},
	{
		collapse: false,
		name: "ManageRouteAssignRouteDriverEdit",
		path: "/transport-setup/assign-route-driver-edit/:id",
		component: ManageRouteAssignRouteDriverEdit
	},
	{
		collapse: false,
		name: "ManageRouteAssignRouteDriverAdd",
		path: "/transport-setup/assign-route-driver-add",
		component: ManageRouteAssignRouteDriverAdd
	},
	{
		collapse: false,
		name: "ManageRouteAssignRouteDriver",
		path: "/transport-setup/assign-route-driver",
		component: ManageRouteAssignRouteDriver
	},
	{
		collapse: false,
		name: "ManageRouteComposeRouteEdit",
		path: "/transport-setup/manage-route/compose-route-edit/:id",
		component: ManageRouteComposeRouteEdit
	},
	{
		collapse: false,
		name: "ManageRouteComposeRouteAdd",
		path: "/transport-setup/manage-route/compose-route-add",
		component: ManageRouteComposeRouteAdd
	},
	{
		collapse: false,
		name: "ManageRouteComposeRoute",
		path: "/transport-setup/manage-route/compose-route",
		component: ManageRouteComposeRoute
	},
	{
		collapse: false,
		name: "ManageRouteRouteEdit",
		path: "/transport-setup/manage-route/route-edit/:id",
		component: ManageRouteRouteEdit
	},
	{
		collapse: false,
		name: "ManageRouteRouteAdd",
		path: "/transport-setup/manage-route/route-add",
		component: ManageRouteRouteAdd
	},
	{
		collapse: false,
		name: "ManageRouteRoute",
		path: "/transport-setup/manage-route/route",
		component: ManageRouteRoute
	},
	{
		collapse: false,
		name: "ManageRouteStopEdit",
		path: "/transport-setup/manage-route/stop-edit/:id",
		component: ManageRouteStopEdit
	},
	{
		collapse: false,
		name: "ManageRouteStopAdd",
		path: "/transport-setup/manage-route/stop-add",
		component: ManageRouteStopAdd
	},
	{
		collapse: false,
		name: "ManageRouteStop",
		path: "/transport-setup/manage-route/stop",
		component: ManageRouteStop
	},
	{
		collapse: false,
		name: "CheckRoute",
		path: "/transport-setup/check-route",
		component: CheckRoute
	},
	{
		collapse: false,
		name: "CheckRouteDetails",
		path: "/transport-setup/check-route-details/:text/:id",
		component: CheckRouteDetails
	},
	{
		collapse: false,
		name: "CheckRouteAttendance",
		path: "/transport-setup/check-route-attendance/:text/:id",
		component: CheckRouteAttendance
	},
	{
		collapse: false,
		name: "OngoingRouteDetails",
		path: "/transport-setup/ongoing-route/:name/:id",
		component: OngoingRouteDetails
	},
	{
		collapse: false,
		name: "OngoingRoute",
		path: "/transport-setup/ongoing-route",
		component: OngoingRoute
	},
	{
		collapse: false,
		name: "BusOnMap",
		path: "/transport-setup/bus-on-map",
		component: BusOnMap
	},
	{
		collapse: false,
		name: "OngoingRouteHistoryDetails",
		path: "/transport-setup/ongoing-route-history/:date/:name/:id",
		component: OngoingRouteHistoryDetails
	},
	{
		collapse: false,
		name: "OngoingRouteHistory",
		path: "/transport-setup/ongoing-route-history",
		component: OngoingRouteHistory
	},
	{
		collapse: false,
		name: "RouteTrackersHistory",
		path: "/transport-setup/route-tracker-history",
		component: RouteTrackersHistory
	},
	{
		collapse: false,
		name: "RouteTrackers",
		path: "/transport-setup/route-tracker",
		component: RouteTrackers
	},
	{
		collapse: false,
		name: "ChildrenProfilesAdd",
		path: "/student/add",
		component: ChildrenProfilesAdd
	},
	{
		collapse: false,
		name: "ChildrenProfilesView",
		path: "/student/view/:id",
		component: ChildrenProfilesView
	},
	{
		collapse: false,
		name: "ChildrenProfilesEdit",
		path: "/student/edit/:id",
		component: ChildrenProfilesEdit
	},
	{
		collapse: false,
		name: "ChildrenProfilesDocument",
		path: "/student/document/:id",
		component: ChildrenProfilesDocument
	},
	{
		collapse: false,
		name: "ChildrenProfilesDaycareFees",
		path: "/student/daycare/:id",
		component: ChildrenProfilesDaycareFees
	},
	{
		collapse: false,
		name: "ChildrenProfilesTransportFees",
		path: "/student/transport/:id",
		component: ChildrenProfilesTransportFees
	},
	{
		collapse: false,
		name: "ChildrenProfilesFees",
		path: "/student/fees/:id",
		component: ChildrenProfilesFees
	},
	{
		collapse: false,
		name: "ChildrenProfilesFeesPay",
		path: "/student/pay-fees/:id",
		component: ChildrenProfilesFeesPay
	},
	{
		collapse: false,
		name: "ChildrenProfilesFeesView",
		path: "/student/view-fees/:id",
		component: ChildrenProfilesFeesView
	},
	{
		collapse: false,
		name: "ChildrenPromote",
		path: "/student/promote/:id",
		component: ChildrenPromote
	},
	{
		collapse: false,
		name: "StudentFeesReport",
		path: "/student/fees-report/:id",
		component: StudentFeesReport
	},
	{
		collapse: false,
		name: "StudentTracker",
		path: "/student/tracker/:id",
		component: StudentTracker
	},
	{
		collapse: false,
		name: "ClassWiseTracker",
		path: "/class/tracker",
		component: ClassWiseTracker
	},
	{
		collapse: false,
		name: "ClassWiseFees",
		path: "/class/fees-graph",
		component: ClassWiseFees
	},
	{
		collapse: false,
		name: "SchoolWiseTracker",
		path: "/school-wise-tracker",
		component: SchoolWiseTracker
	},
	{
		collapse: false,
		name: "AttendanceTracker",
		path: "/attendance-tracker",
		component: AttendanceTracker
	},
	{
		collapse: false,
		name: "AddmissionDeactive",
		path: "/admission/archive",
		component: AddmissionDeactive
	},
	{
		collapse: false,
		name: "ChildrenDeactive",
		path: "/student/archive",
		component: ChildrenDeactive
	},
	{
		collapse: false,
		name: "ChildrenAll",
		path: "/children-profiles/children-all",
		component: ChildrenAll
	},
	{
		collapse: false,
		name: "FeesSuccessReportView",
		path: "/fees-report/view/:id",
		component: FeesSuccessReportView
	},
	{
		collapse: false,
		name: "ConcernView",
		path: "/parents-concern/view/:id",
		component: ConcernView
	},
	{
		collapse: false,
		name: "StaffConcernView",
		path: "/staff-concern/view/:id",
		component: StaffConcernView
	},
	{
		collapse: false,
		name: "UpcomingBusExpiry",
		path: "/upcoming-bus-expiry",
		component: UpcomingBusExpiry
	},
	{
		collapse: false,
		name: "ExpiredBusList",
		path: "/expired-bus-list",
		component: ExpiredBusList
	},
	{
		collapse: false,
		name: "EmailReport",
		path: "/report/:text",
		component: EmailReport
	},
	{
		collapse: false,
		name: "ManageClass",
		path: "/manage-class/class",
		component: ManageClass
	},
	{
		collapse: false,
		name: "ManageClassAdd",
		path: "/manage-class/class-add",
		component: ManageClassAdd
	},
	{
		collapse: false,
		name: "ManageClassEdit",
		path: "/manage-class/class-edit/:id",
		component: ManageClassEdit
	},
	{
		collapse: false,
		name: "ManageDivision",
		path: "/manage-class/division",
		component: ManageDivision
	},
	{
		collapse: false,
		name: "ManageDivisionAdd",
		path: "/manage-class/division-add",
		component: ManageDivisionAdd
	},
	{
		collapse: false,
		name: "ManageDivisionEdit",
		path: "/manage-class/division-edit/:id",
		component: ManageDivisionEdit
	},
	{
		collapse: false,
		name: "ManageSubject",
		path: "/manage-class/subject",
		component: ManageSubject
	},
	{
		collapse: false,
		name: "ManageSubjectAdd",
		path: "/manage-class/subject-add",
		component: ManageSubjectAdd
	},
	{
		collapse: false,
		name: "ManageSubjectEdit",
		path: "/manage-class/subject-edit/:id",
		component: ManageSubjectEdit
	},
	{
		collapse: false,
		name: "Managestar",
		path: "/manage-class/star",
		component: Managestar
	},
	{
		collapse: false,
		name: "ManagestarAdd",
		path: "/manage-class/star-add",
		component: ManagestarAdd
	},
	{
		collapse: false,
		name: "ManagestarEdit",
		path: "/manage-class/star-edit/:id",
		component: ManagestarEdit
	},
	{
		collapse: false,
		name: "FeesSuccessReport",
		path: "/fees-report/:text",
		component: FeesSuccessReport
	},
	{
		collapse: false,
		name: "FeesReconciliationReport",
		path: "/fees-reconciliation/:text",
		component: FeesReconciliationReport
	},
	{
		collapse: false,
		name: "FeesRefund",
		path: "/fees-refund",
		component: FeesRefund
	},
	{
		collapse: false,
		name: "ChildrenAdmissionProcess",
		path: "/admission-process",
		component: ChildrenAdmissionProcess
	},
	{
		collapse: false,
		name: "ChildrenProfiles",
		path: "/children-profiles",
		component: ChildrenProfiles
	},
	{
		collapse: false,
		name: "Reports",
		path: "/reports/index",
		component: Reports
	},
	{
		collapse: false,
		name: "ReportsAdmision",
		path: "/reports/reports_admision",
		component: ReportsAdmision
	},
	{
		collapse: false,
		name: "FeePayment",
		path: "/reports/fee-payment",
		component: FeePayment
	},
	{
		collapse: false,
		name: "ChildrenAttendance",
		path: "/reports/children-attendance",
		component: ChildrenAttendance
	},
	{
		collapse: false,
		name: "StaffAttendance",
		path: "/reports/staff-attendance",
		component: StaffAttendance
	},
	{
		collapse: false,
		name: "StudentAttendanceReport",
		path: "/reports/student-attendance-report",
		component: StudentAttendanceReport
	},
	{
		collapse: false,
		name: "StudentMonthAttendanceReport",
		path: "/reports/student-month-attendance-report",
		component: StudentMonthAttendanceReport
	},
	{
		collapse: false,
		name: "EnquiryReport",
		path: "/reports/enquiry-report",
		component: EnquiryReport
	},
	{
		collapse: false,
		name: "PtmReport",
		path: "/reports/ptm-report",
		component: PtmReport
	},
	{
		collapse: false,
		name: "PtmReportDetails",
		path: "/reports/ptm-report-details/:id",
		component: PtmReportDetails
	},
	{
		collapse: false,
		name: "ChildrenReport",
		path: "/reports/children-report",
		component: ChildrenReport
	},
	{
		collapse: false,
		name: "AccountFeesReport",
		path: "/reports/account-fees-report",
		component: AccountFeesReport
	},
	{
		collapse: false,
		name: "AccountDayWiseFeesReport",
		path: "/reports/day-wise-fees-report",
		component: AccountDayWiseFeesReport
	},
	{
		collapse: false,
		name: "StudentEscortCardReport",
		path: "/reports/student-escort-card-report",
		component: StudentEscortCardReport
	},
	{
		collapse: false,
		name: "TodayFeesReport",
		path: "/reports/today-fees-report",
		component: TodayFeesReport
	},
	{
		collapse: false,
		name: "TodayEnquiryReport",
		path: "/reports/today-enquiry-report",
		component: TodayEnquiryReport
	},
	{
		collapse: false,
		name: "TodayAdmissionReport",
		path: "/reports/today-admission-report",
		component: TodayAdmissionReport
	},
	{
		collapse: false,
		name: "TodayConversionReport",
		path: "/reports/today-conversion-report",
		component: TodayConversionReport
	},
	{
		collapse: false,
		name: "TodayFollowupReport",
		path: "/reports/today-followup-report",
		component: TodayFollowupReport
	},
	{
		collapse: false,
		name: "TransportReport",
		path: "/reports/transport-report",
		component: TransportReport
	},
	{
		collapse: false,
		name: "ChildrenFeesReport",
		path: "/reports/children-fees-report",
		component: ChildrenFeesReport
	},
	{
		collapse: false,
		name: "ChildrenFeesReport",
		path: "/reports/children-fees-due-report",
		component: ChildrenFeesDueReport
	},
	{
		collapse: false,
		name: "ChildrenFeesChangeReport",
		path: "/reports/children-fees-change-report",
		component: ChildrenFeesChangeReport
	},
	{
		collapse: false,
		name: "ChildrenFeesReportDetails",
		path: "/reports/children-fees-report-details/:id",
		component: ChildrenFeesReportDetails
	},
	{
		collapse: false,
		name: "History",
		path: "/history/index",
		component: History
	},
	{
		collapse: false,
		name: "AddEvent",
		path: "/calendar/add-event",
		component: AddEvent
	},
	{
		collapse: false,
		name: "EditEvent",
		path: "/calendar/edit-event/:id",
		component: EditEvent
	},
	{
		collapse: false,
		name: "Calendar",
		path: "/calendar",
		component: Calendar
	},
	{
		collapse: false,
		name: "shop",
		path: "/shop",
		component: Shop
	},
	{
		collapse: false,
		name: "shop_kit",
		path: "/shop_kit",
		component: ShopKit
	},
	{
		collapse: false,
		name: "Expenses",
		path: "/expenses/index",
		component: Expenses
	},
	{
		collapse: false,
		name: "ExpensesAdd",
		path: "/expenses/expenses-add",
		component: ExpensesAdd
	},
	{
		collapse: false,
		name: "ExpensesEdit",
		path: "/expenses/expenses-edit/:id",
		component: ExpensesEdit
	},
	{
		collapse: false,
		name: "MainProfile",
		path: "/profile/index",
		component: MainProfile
	},
	{
		collapse: false,
		name: "ChangePassword",
		path: "/change-password",
		component: ChangePassword
	},
	{
		collapse: false,
		name: "PrivacyPolicy",
		path: "/privacy-policy",
		component: PrivacyPolicy
	},
	{
		collapse: false,
		name: "Company Search",
		path: "/company/:name/:id",
		component: Home
	},

	{
		collapse: false,
		name: "Dashboard",
		path: "/dashboard",
		component: Dashboard
	},

	{
		collapse: false,
		name: "ConsolidatedReport",
		path: "/consolidated-report",
		component: ConsolidatedReport
	},
	{
		collapse: false,
		name: "EmailSetting",
		path: "/email-setting",
		component: EmailSetting
	},

	{
		collapse: false,
		name: "HomeDashboard",
		path: "/home-dashboard",
		component: HomeDashboard
	},
	{
		collapse: false,
		name: "AdminChangePassword",
		path: "/admin-change-password",
		component: AdminChangePassword
	},
	{
		collapse: false,
		name: "Home",
		path: "/",
		component: Home
	}

];
export default KCISThemeRoutes;
